import { Box, Group, SegmentedControl, Stack, Text, Title } from "@mantine/core";
import { useState } from "react";
import { useTranslation } from "react-i18next";

import { AufgabenListe } from "../components/aufgaben/AufgabenListe.js";
import { BereichSicht } from "../components/aufgaben/BereichSicht.js";
import { hasRole, useCurrentUser } from "../hooks/useAuth.js";
import { useBereich } from "../hooks/useAufgaben.js";

type Sicht = "meine" | "bereich";

/**
 * Startseite „Aufgaben" (#361): was die angemeldete Person selbst erledigen
 * kann, und für Führung die Sicht „Mein Bereich" je Service Lead. Die
 * Bereichsdaten lädt die Seite erst, wenn der Reiter offen ist.
 */
export function AufgabenPage() {
  const { t } = useTranslation();
  const { user } = useCurrentUser();
  // Dieselben Rollen wie GET /dashboard/bereich; alle anderen bekämen 403.
  const darfBereich = hasRole(user, ["admin", "geschaeftsleitung", "bereichsleiter", "stellvertreter"]);
  const [sicht, setSicht] = useState<Sicht>("meine");
  const bereichOffen = darfBereich && sicht === "bereich";
  const bereich = useBereich(bereichOffen);

  return (
    <Stack gap="lg">
      <Group justify="space-between" align="flex-end" wrap="wrap" gap="md">
        <Box>
          <Title order={2}>{t("pages.dashboard.title")}</Title>
          <Text size="sm" c="dimmed" mt={6}>
            {t("aufgaben.untertitel")}
          </Text>
        </Box>
        {darfBereich ? (
          <SegmentedControl
            aria-label={t("aufgaben.sicht.label")}
            value={sicht}
            onChange={(v) => setSicht(v as Sicht)}
            data={[
              { value: "meine", label: t("aufgaben.sicht.meine") },
              { value: "bereich", label: t("aufgaben.sicht.bereich") },
            ]}
          />
        ) : null}
      </Group>

      {bereichOffen ? (
        <BereichSicht data={bereich.data} isLoading={bereich.isLoading} error={bereich.error} />
      ) : (
        <AufgabenListe />
      )}
    </Stack>
  );
}
